module.exports = __webpack_public_path__ + "static/media/1.3.2-dashboard-group-inv.f9ab4fdf.jpg";